import { render, staticRenderFns } from "./LabelReleasesValidationErrorDialog.vue?vue&type=template&id=236630c1"
import script from "./LabelReleasesValidationErrorDialog.vue?vue&type=script&lang=js"
export * from "./LabelReleasesValidationErrorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports